class BookingPaymentMethodDisagioCheckboxListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('change', context.selector, function (){


            let current = $(this);

            let panel = current.closest('.panel');

            let banqu_account_id = panel.find('#banqu_account_id').val();


            let session_fields = new BookingPaymentMethodDisagioSessionField($('#global_user_id').val(), banqu_account_id);

            if(current.prop('checked'))
                session_fields.putInSession(1);
            else
                session_fields.removeFromSession();
        });

    }

}